
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-xflow-components-graph-demo-xflow-components-xflow-graph"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/components/graph.zh.md?type=demo')
};